export const publicNav = [
  { label: 'Home', path: '/' },
  { label: 'About', path: '/about' },
  { label: 'Sikhism', path: '/sikhism' },
  { label: 'Gurbani Library', path: '/gurbani-library' },
  { label: 'Daily Hukamnama', path: '/hukamnama' },
  { label: 'Events', path: '/events' },
  { label: 'Bookings', path: '/bookings' },
  { label: 'Family Dashboard', path: '/family-dashboard' },
  { label: 'Seva', path: '/seva' },
  { label: 'Donation', path: '/donation' },
  { label: 'Media', path: '/media' },
  { label: 'Library', path: '/library' },
  { label: 'News', path: '/news' },
  { label: 'FAQ', path: '/faq' },
  { label: 'Contact', path: '/contact' }
];

export const adminNav = [
  { label: 'Dashboard', path: '/admin' },
  { label: 'CMS', path: '/admin/cms' },
  { label: 'News and Updates', path: '/admin/news' },
  { label: 'Daily Schedule', path: '/admin/schedule' },
  { label: 'Hukamnama', path: '/admin/hukamnama' },
  { label: 'Seva Items', path: '/admin/langar' },
  { label: 'Seva Opportunities', path: '/admin/seva-opportunities' },
  { label: 'Gallery Folders', path: '/admin/gallery' },
  { label: 'Library', path: '/admin/library' },
  { label: 'Videos', path: '/admin/videos' },
  { label: 'Streaming', path: '/admin/streaming' },
  { label: 'Advertisements', path: '/admin/advertisements' },
  { label: 'Sponsors', path: '/admin/sponsors' },
  { label: 'Events', path: '/admin/events' },
  { label: 'Bookings', path: '/admin/bookings' },
  { label: 'Kids Learning', path: '/admin/kids-learning' },
  { label: 'Donations', path: '/admin/donations' },
  { label: 'Newsletter', path: '/admin/newsletter' },
  { label: 'Audit Trail', path: '/admin/audit-trail' },
  { label: 'Roles and Access', path: '/admin/roles-access' },
  { label: 'Users', path: '/admin/users' }
];
